import { RootState } from '@app/store'
import { DEV } from '@config'
import { api as eventApi } from './auto-generated/event'
import { createSocket } from './ws'
import { agoraApi } from './agora'
import { geoguesserApi } from './geoguesser'
import { discussionApi } from './discussion'

eventApi.enhanceEndpoints({
  endpoints: {
    eventGetEventById: {
      async onCacheEntryAdded(
        arg,
        { updateCachedData, cacheDataLoaded, cacheEntryRemoved, getState, dispatch },
      ) {
        const { tokens } = (getState() as RootState).auth
        const { eventId } = arg
        if (tokens && eventId) {
          // create a websocket connection when the cache subscription starts
          let ws
          try {
            console.log('workin')
            // wait for the initial query to resolve before proceeding
            await cacheDataLoaded
            console.log('workin')
            const listener = (event: MessageEvent) => {
              const data = JSON.parse(event.data)
              // if (!isMessage(data) || data.channel !== arg) return   TODO add isMessage validator schema
              if (DEV) console.log(data)
              switch (data.event_type) {
                case 'JOIN_ROOM':
                  updateCachedData((draftEvent) => {
                    if (
                      draftEvent.users?.findIndex(
                        (elem) => elem.id === data.event_message.user.id,
                      ) === -1
                    )
                      draftEvent.users.push(data.event_message.user)
                  })
                  break
                case 'CHANGE_EVENT_TYPE':
                  updateCachedData((draftEvent) => {
                    if (data.event_message.new_type !== 'NONE') {
                      draftEvent.event_type = data.event_message.new_type
                    }
                  })
                  break
                case 'CHANGE_HOST':
                  updateCachedData((draftEvent) => {
                    draftEvent.host = data.event_message?.new_host
                  })
                  break
                case 'CHANGE_CURRENT_ROOM':
                  updateCachedData((draftEvent) => {
                    draftEvent.current_room_id = data.event_message?.new_room_id
                  })
                  break
                case 'AGORA_USER_CHANGED_ROOM':
                  updateCachedData((draftEvent) => {
                    draftEvent.users_partition = data.event_message.users_partition
                  })
                  break
                // case 'AGORA_CREATE_NEW_ROOM':
                //   dispatch(
                //     agoraApi.util.updateQueryData(
                //       'agoraGetRtcRooms',
                //       { eventId },
                //       (draftRtcRooms) => {
                //         console.log(draftRtcRooms)
                //         draftRtcRooms.push(data.event_message)
                //       },
                //     ),
                //   )

                //   break
                // case 'NEXT_ROUND':
                //   dispatch(
                //     geoguesserApi.endpoints.geoguesserGetAllGameResult.initiate(
                //       {
                //         eventId,
                //       },
                //       { forceRefetch: true },
                //     ),
                //   )
                //   dispatch(
                //     geoguesserApi.endpoints.geoguesserGetGameCoordinates.initiate(
                //       {
                //         eventId,
                //       },
                //       { forceRefetch: true },
                //     ),
                //   )
                //   break
                // case 'SET_DISCUSSION_TOPIC':
                //   dispatch(
                //     discussionApi.util.updateQueryData(
                //       'discussionGetCurrentDiscussionTopic',
                //       { eventId },
                //       (draftTopic) => {
                //         draftTopic = data.event_message.discussion_topic
                //         return draftTopic
                //       },
                //     ),
                //   )
                //   break
                default:
                  break
              }
            }
            ws = await createSocket(eventId, listener)

            // when data is received from the socket connection to the server,
            // if it is a message and for the appropriate channel,
            // update our query result with the received message
            // ws.addEventListener('message', listener)
          } catch (error) {
            console.log(error)
            // no-op in case `cacheEntryRemoved` resolves before `cacheDataLoaded`,
            // in which case `cacheDataLoaded` will throw
          }
          // cacheEntryRemoved will resolve when the cache subscription is no longer active
          await cacheEntryRemoved
          // perform cleanup steps once the `cacheEntryRemoved` promise resolves
          if (ws) {
            ws.close()
          }
        }
      },
    },
    // eventGetCurrentEvent: {
    //   async onCacheEntryAdded(
    //     arg,
    //     { updateCachedData, cacheDataLoaded, cacheEntryRemoved, getState, dispatch },
    //   ) {
    //     const { tokens } = (getState() as RootState).auth
    //     const { data: currentEvent } = await cacheDataLoaded
    //     const eventId = currentEvent.event_id

    //     // if (tokens && eventId) {
    //     //   // create a websocket connection when the cache subscription starts
    //     //   // const ws = createSocket(tokens?.access_token?.token, eventId)
    //     //   try {
    //     //     // wait for the initial query to resolve before proceeding

    //     //     // when data is received from the socket connection to the server,
    //     //     // if it is a message and for the appropriate channel,
    //     //     // update our query result with the received message
    //     //     const listener = (event: MessageEvent) => {
    //     //       const data = JSON.parse(event.data)
    //     //       // if (!isMessage(data) || data.channel !== arg) return   TODO add isMessage validator schema
    //     //       updateCachedData((draftEvent) => {
    //     //         switch (data.event_type) {
    //     //           case 'JOIN_ROOM':
    //     //             if (
    //     //               draftEvent.users?.findIndex(
    //     //                 (elem) => elem.id === data.event_message.user.id,
    //     //               ) === -1
    //     //             )
    //     //               draftEvent.users.push(data.event_message.user)
    //     //             break
    //     //           case 'CHANGE_EVENT_TYPE':
    //     //             console.log('event changed', data.event_message.new_type)
    //     //             if (data.event_message.new_type !== 'NONE') {
    //     //               draftEvent.event_type = data.event_message.new_type
    //     //             }
    //     //             break
    //     //           case 'CHANGE_HOST':
    //     //             draftEvent.host = data.event_message?.new_host
    //     //             break
    //     //           default:
    //     //             break
    //     //         }
    //     //       })
    //     //     }
    //     //     ws.addEventListener('message', listener)
    //     //   } catch {
    //     //     // no-op in case `cacheEntryRemoved` resolves before `cacheDataLoaded`,
    //     //     // in which case `cacheDataLoaded` will throw
    //     //   }
    //     //   // cacheEntryRemoved will resolve when the cache subscription is no longer active
    //     //   await cacheEntryRemoved
    //     //   // perform cleanup steps once the `cacheEntryRemoved` promise resolves
    //     //   ws.close()
    //     // }
    //   },
    // },
    eventParticipateInEvent: {
      async onQueryStarted(args, { dispatch, queryFulfilled, getState }) {
        try {
          await queryFulfilled
          const { user } = (getState() as RootState).auth
          dispatch(
            eventApi.util.updateQueryData('eventGetEventById', args, (draftEvent) => {
              draftEvent.participants = [...draftEvent.participants, user]
            }),
          )
        } catch {}
      },
    },
    eventDeleteParticipationInEvent: {
      async onQueryStarted(args, { dispatch, queryFulfilled, getState }) {
        try {
          await queryFulfilled
          const { user } = (getState() as RootState).auth
          dispatch(
            eventApi.util.updateQueryData('eventGetEventById', args, (draftEvent) => {
              let array = draftEvent.participants
              const index = array.indexOf(user)
              array.splice(index, 1)
            }),
          )
        } catch {}
      },
    },
  },
})

export { eventApi }

export * from './auto-generated/event'
